export default "__VITE_ASSET__xc7KoMwn__"